// Utils
import { dispatchCloseTooltipEventOnThisElement } from '../utils/dispatchCloseTooltipEventOnThisElement';
import { dispatchOpenTooltipEventOnThisElement } from '../utils/dispatchOpenTooltipEventOnThisElement';
import { useMemo } from 'react';
export var useTooltip = function (subscribedTooltipEventElement) {
    return useMemo(function () { return ({
        openTooltip: dispatchOpenTooltipEventOnThisElement(subscribedTooltipEventElement),
        closeTooltip: dispatchCloseTooltipEventOnThisElement(subscribedTooltipEventElement),
    }); }, [subscribedTooltipEventElement]);
};
//# sourceMappingURL=useTooltip.js.map